import type { TerminalBatchUpdateDto } from "src/app/features/Terminal/types/TerminalBatchUpdateDto";
import type { TerminalBatchUpdateEntity } from "src/app/features/Terminal/types/TerminalBatchUpdateEntity";

export const TerminalBatchUpdateEntityToBatchUpdateDto = ({ ...rest }: Readonly<TerminalBatchUpdateEntity>): TerminalBatchUpdateDto => {
    return { ...rest };
};
